import { Box, type Colors, InfoDot, Text } from '@factorialco/deprecated-design-system'
import { animated, useSpring } from '@react-spring/web'

type Props = {
  title: string
  value: number
  color: Colors
}

export const SummaryCard = ({ title, value, color }: Props) => {
  const spring = useSpring({ value })

  return (
    <Box gap="s2">
      <Text.Normal size="200" weight="medium" color="grey1000">
        {title}
      </Text.Normal>

      <Box flexDirection="row" gap="s8" alignItems="center">
        <InfoDot size="medium" color={color} />
        <Text size="500" weight="medium" color="grey1000">
          <animated.div>
            {spring.value.to((currentValue) =>
              currentValue < value ? Math.ceil(currentValue) : Math.floor(currentValue)
            )}
          </animated.div>
        </Text>
      </Box>
    </Box>
  )
}
